import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.881 8.424c.25-.25.59-.39.943-.39h10.667a1.333 1.333 0 0 1 1.333 1.333V10.7a1.334 1.334 0 0 1-1.333 1.333H2.824A1.334 1.334 0 0 1 1.491 10.7V9.367c0-.354.14-.693.39-.943m11.61.943H2.824V10.7h10.667z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.491 8.033c.368 0 .667.299.667.667v2.667a.667.667 0 1 1-1.334 0V8.7c0-.368.299-.667.667-.667M10.824 2.7c.369 0 .667.298.667.667V3.7a.667.667 0 0 0 .667.667 2 2 0 0 1 2 2V6.7a.667.667 0 1 1-1.334 0v-.333a.666.666 0 0 0-.666-.667 2 2 0 0 1-2-2v-.333c0-.369.298-.667.666-.667",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })